import { gate } from 'hub-http/gates';
export const INBOX_LONG_TASK_REPORT = 'Conversations:InboxLongTaskReport';
export const WHATSAPP = 'Conversations:WhatsApp';
export const POP_OUT_COMPOSER = 'Communication:Composer:PopOutComposer';
export const GRAPHQL_ASSIGNEES = 'Conversations:GraphQLAssignees';
export const EMAIL_FORWARD_HISTORY = 'Communication:EmailForwardHistory';
export const USER_DEFAULT_FONTS = 'Communication:UserDefaultFonts';
export const CONVERSATION_SUMMARY = 'Communication:AI:ConversationSummary';
export const CONTACT_PROMOTION = 'HelpDesk:ContactPromotions';
export const CALLING_NEXT_BEST_ACTIONS = 'Calling:Rep:NextBestActions';
export const HELP_DESK_ROUTING_SCOPE_FILTERING = 'HelpDeskRoutingScopeFiltering';
export const SYSTEM_MESSAGE_REDESIGN = 'Communication:RepMsg:SystemMessageRedesign';
export const CHATSPOT_WIDGET_BETA = 'Chatspot:Widget:Beta';
export const NOTE_POWERED_COLLABORATION = gate('HelpDesk:NotePoweredCollaboration');
// NOTE: if adding a new gate to use exclusively in conversations-inbox-message-history
// STOP, it's easier to add it directly to conversations-inbox-message-history here:
// https://git.hubteam.com/HubSpot/conversations-inbox-message-history/blob/master/static/js/util/gateHooks.ts